"use client";

import { createContext, useContext } from "react";
import { motion, AnimatePresence } from "framer-motion";
import useNetworkStatus from "@/utils/hooks/useNetworkStatus";

const LoadingContext = createContext<{ loading: boolean }>({ loading: false });

export const LoadingProvider = ({ children }: { children: React.ReactNode }) => {
  const { isOnline, hasNetworkError } = useNetworkStatus();

  return (
    <LoadingContext.Provider value={{ loading: !isOnline }}>
      <AnimatePresence>
        {hasNetworkError({ options: { showToast: false } }) && (
          <motion.div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <div className="text-md text-primary-light">
              Network error detected. Please check your connection and try again
            </div>
          </motion.div>
        )}
      </AnimatePresence>
      {children}
    </LoadingContext.Provider>
  );
};

export const useLoading = () => useContext(LoadingContext);
